module.exports = __webpack_public_path__ + "img/Season'sGreetings.0cd7d1d8.png";